/**
 * Asynchronously loads the component for NotFoundPage
 */
import { lazyRoute } from 'components/LazyRoute'

export default lazyRoute(() => import('./index'))
